import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "../utils/axiosInstance";
import { useDialog, useToast } from "./ConfirmDialog";

const Styles = () => (
  <style>{`
.mihanda-wrap { font-family: 'Nunito Sans', system-ui, sans-serif; color: #1e293b; }
.mihanda-wrap * { box-sizing: border-box; }

.mihanda-topbar { display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; flex-wrap:wrap; gap:10px; }
.mihanda-title { font-size:20px; font-weight:800; color:#1a3a5c; margin:0; }
.mihanda-subtitle { font-size:12px; color:#64748b; margin:2px 0 0; }

.mihanda-tabs { display:flex; gap:6px; flex-wrap:wrap; margin-bottom:20px; }
.mihanda-tab { padding:9px 16px; border-radius:8px; border:1px solid #d1d9e6; background:#fff; color:#475569; font-size:13px; font-weight:600; cursor:pointer; }
.mihanda-tab.active { background:#1a3a5c; color:#fff; border-color:#1a3a5c; }

.mihanda-card { background:#fff; border:1px solid #e2e8f0; border-radius:10px; padding:20px; margin-bottom:16px; }
.mihanda-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:14px; }

.mihanda-field { margin-bottom:14px; }
.mihanda-field label { display:block; font-size:12px; font-weight:700; color:#475569; margin-bottom:5px; }
.mihanda-field label .required { color:#dc2626; }
.mihanda-field input, .mihanda-field select, .mihanda-field textarea {
  width:100%; padding:10px 12px; border:1px solid #d1d9e6; border-radius:6px; font-size:14px; background:#f8fafc; font-family:inherit;
}
.mihanda-field textarea { min-height:90px; resize:vertical; line-height:1.6; }
.mihanda-field input:focus, .mihanda-field select:focus, .mihanda-field textarea:focus { outline:none; border-color:#1a3a5c; background:#fff; }
.mihanda-error { font-size:11.5px; color:#dc2626; margin-top:4px; font-weight:600; }

.mihanda-radio-row { display:flex; gap:18px; padding:6px 0 2px; }
.mihanda-radio-opt { display:flex; align-items:center; gap:7px; font-size:13.5px; font-weight:600; color:#334155; cursor:pointer; }
.mihanda-radio-opt input { width:auto; }

.mihanda-btn { display:inline-flex; align-items:center; gap:6px; padding:10px 18px; border:none; border-radius:7px; font-size:13px; font-weight:700; cursor:pointer; font-family:inherit; }
.mihanda-btn:disabled { opacity:.5; cursor:not-allowed; }
.mihanda-btn-primary { background:#1a3a5c; color:#fff; }
.mihanda-btn-primary:hover:not(:disabled) { background:#0f2a45; }
.mihanda-btn-success { background:#15803d; color:#fff; }
.mihanda-btn-outline { background:transparent; color:#475569; border:1px solid #d1d9e6; }
.mihanda-btn-outline:hover { background:#f1f5f9; }
.mihanda-btn-sm { padding:7px 13px; font-size:12px; }
.mihanda-actions-row { display:flex; gap:10px; flex-wrap:wrap; margin-top:16px; }

.mihanda-table-wrap { overflow-x:auto; }
.mihanda-table { width:100%; border-collapse:collapse; font-size:13px; }
.mihanda-table th { text-align:left; padding:10px 12px; background:#f1f5f9; color:#475569; font-weight:700; white-space:nowrap; }
.mihanda-table td { padding:10px 12px; border-top:1px solid #e2e8f0; vertical-align:top; }
.mihanda-table tr:hover td { background:#f8fafc; cursor:pointer; }
.mihanda-empty { text-align:center; padding:40px 10px; color:#94a3b8; font-size:13px; }

.mihanda-badge { display:inline-block; padding:3px 10px; border-radius:14px; font-size:11px; font-weight:700; white-space:nowrap; }
.mihanda-badge-yateguwe { background:#f1f5f9; color:#475569; }
.mihanda-badge-sent_mudugudu { background:#fef3c7; color:#b45309; }
.mihanda-badge-received_mudugudu { background:#dbeafe; color:#1d4ed8; }
.mihanda-badge-sent_kagari { background:#fef3c7; color:#b45309; }
.mihanda-badge-received_kagari { background:#dbeafe; color:#1d4ed8; }
.mihanda-badge-kurikirana { background:#ede9fe; color:#6d28d9; }
.mihanda-badge-byarangiye { background:#dcfce7; color:#16a34a; }

.mihanda-detail-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); gap:14px; margin-bottom:6px; }
.mihanda-detail-item-label { font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; margin-bottom:3px; }
.mihanda-detail-item-value { font-size:14px; color:#1e293b; font-weight:600; }

.mihanda-pagination { display:flex; align-items:center; justify-content:center; gap:10px; margin-top:14px; }

@media (max-width:768px) {
  .mihanda-tabs { gap:4px; }
  .mihanda-tab { padding:8px 12px; font-size:12px; }
}
`}</style>
);

const STATUS_LABEL = {
  Yateguwe: { label: "Yateguwe", cls: "yateguwe" },
  "Yoherejwe ku Mudugudu": { label: "Yoherejwe ku Mudugudu", cls: "sent_mudugudu" },
  "Yakiriwe n'Umudugudu": { label: "Yakiriwe n'Umudugudu", cls: "received_mudugudu" },
  "Yoherejwe ku Kagari": { label: "Yoherejwe ku Kagari", cls: "sent_kagari" },
  "Yakiriwe n'Akagari": { label: "Yakiriwe n'Akagari", cls: "received_kagari" },
  "Ari gukurikiranwa": { label: "Ari gukurikiranwa", cls: "kurikirana" },
  Byarangiye: { label: "Byarangiye", cls: "byarangiye" },
};

const AKAGARI_NEXT_STATUS = {
  "Yoherejwe ku Kagari": [["Yakiriwe n'Akagari", "Emeza ko Wakiriye"]],
  "Yakiriwe n'Akagari": [["Ari gukurikiranwa", "Tangira Gukurikirana"], ["Byarangiye", "Emeza ko Byarangiye"]],
  "Ari gukurikiranwa": [["Byarangiye", "Emeza ko Byarangiye"]],
};

const emptyForm = {
  child_name: "", age: "", gender: "", location: "", notes: "",
  ariga: "", ishuri: "",
  afite_ababyeyi: "", parent1_name: "", parent2_name: "", parent_phone: "", parent_address: "",
};

const PAGE_SIZE = 15;

/**
 * Abana Bari mu Mihanda (street children) module. `mode` selects which
 * side of the workflow is rendered: 'creator' (Isibo/Umunyamabanga —
 * register + send to Mudugudu), 'village' (Mudugudu — review + forward
 * to Akagari) or 'cell' (Akagari — review + follow-up).
 */
export default function AbanaMuMihanda({ mode }) {
  const { toast } = useToast();
  const { confirm } = useDialog();

  const [activeTab, setActiveTab] = useState("dashboard");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [saving, setSaving] = useState(false);
  const [page, setPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("newest");

  const [form, setForm] = useState(emptyForm);
  const [formErrors, setFormErrors] = useState({});
  const [editingId, setEditingId] = useState(null);

  const [search, setSearch] = useState({ child_name: "", status: "" });

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/abana-mu-mihanda");
      setList(res.data || []);
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Ntibashobotse gupanga urutonde" });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => { fetchList(); }, [fetchList]);

  const loadDetail = async (id) => {
    try {
      const res = await axios.get(`/api/abana-mu-mihanda/${id}`);
      setDetail(res.data);
      setActiveTab("detail");
    } catch (e) {
      toast({ type: "danger", title: "Ikosa", message: e.response?.data?.error || "Ntibyashobotse gufungura amakuru" });
    }
  };

  const validateForm = () => {
    const errs = {};
    if (!form.child_name.trim()) errs.child_name = "Izina ry'umwana rirakenewe";
    const ageNum = Number(form.age);
    if (!form.age || !Number.isFinite(ageNum) || ageNum <= 0) errs.age = "Imyaka igomba kuba umubare uzuye kandi urenze zero";
    if (!form.ariga) errs.ariga = "Hitamo niba umwana ariga";
    else if (form.ariga === "yego" && !form.ishuri.trim()) errs.ishuri = "Ishuri yigamo rirakenewe";
    if (!form.afite_ababyeyi) errs.afite_ababyeyi = "Hitamo niba umwana afite ababyeyi cyangwa abamurera";
    else if (form.afite_ababyeyi === "yego" && !form.parent1_name.trim()) errs.parent1_name = "Izina ry'umubyeyi/umurezi wa mbere rirakenewe";
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const updateField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const buildPayload = () => ({
    child_name: form.child_name.trim(),
    age: Number(form.age),
    gender: form.gender || null,
    location: form.location || null,
    notes: form.notes || null,
    ariga: form.ariga === "yego",
    ishuri: form.ariga === "yego" ? form.ishuri.trim() : "Ntago yiga",
    afite_ababyeyi: form.afite_ababyeyi === "yego",
    parent1_name: form.afite_ababyeyi === "yego" ? form.parent1_name.trim() : null,
    parent2_name: form.afite_ababyeyi === "yego" ? (form.parent2_name || null) : null,
    parent_phone: form.afite_ababyeyi === "yego" ? (form.parent_phone || null) : null,
    parent_address: form.afite_ababyeyi === "yego" ? (form.parent_address || null) : null,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast({ type: "warning", title: "Uzuza ibisabwa", message: "Reba amakosa yagaragajwe muri iyi form" });
      return;
    }
    setSaving(true);
    try {
      if (editingId) {
        await axios.put(`/api/abana-mu-mihanda/${editingId}`, buildPayload());
        toast({ type: "success", title: "Byabitswe", message: "Amakuru y'umwana yahinduwe neza" });
      } else {
        await axios.post("/api/abana-mu-mihanda", buildPayload());
        toast({ type: "success", title: "Byoherejwe", message: "Amakuru y'umwana yohererejwe ku Mudugudu neza." });
      }
      setForm(emptyForm);
      setEditingId(null);
      setFormErrors({});
      fetchList();
      setActiveTab("list");
    } catch (e2) {
      toast({ type: "danger", title: "Ikosa", message: e2.response?.data?.error || "Ntibyabashije kubikwa" });
    } finally {
      setSaving(false);
    }
  };

  const handleForwardToAkagari = () => {
    confirm({
      type: "info",
      title: "Urashaka koko kohereza aya makuru ku Kagari?",
      message: `Amakuru ya ${detail.child_name} azoherezwa ku Kagari.`,
      confirmText: "YEGO, OHEREZA",
      cancelText: "OYA",
      onConfirm: async () => {
        try {
          await axios.post(`/api/abana-mu-mihanda/${detail.id}/forward-to-akagari`);
          toast({ type: "success", title: "Byoherejwe", message: "Amakuru yoherejwe ku Kagari neza" });
          await loadDetail(detail.id);
          fetchList();
        } catch (e2) {
          toast({ type: "danger", title: "Ikosa", message: e2.response?.data?.error || "Ntibyashobotse kohereza" });
        }
      },
    });
  };

  const handleStatusChange = (nextStatus, actionLabel) => {
    confirm({
      type: "info",
      title: `${actionLabel}?`,
      message: `Imiterere ya ${detail.child_name} izahinduka igere kuri "${STATUS_LABEL[nextStatus]?.label}".`,
      confirmText: "YEGO, EMEZA",
      cancelText: "OYA",
      onConfirm: async () => {
        try {
          await axios.patch(`/api/abana-mu-mihanda/${detail.id}/status`, { status: nextStatus });
          toast({ type: "success", title: "Byahinduwe", message: "Imiterere yahinduwe neza" });
          await loadDetail(detail.id);
          fetchList();
        } catch (e2) {
          toast({ type: "danger", title: "Ikosa", message: e2.response?.data?.error || "Ntibyashobotse guhindura" });
        }
      },
    });
  };

  const startEdit = (child) => {
    setForm({
      child_name: child.child_name || "",
      age: String(child.age || ""),
      gender: child.gender || "",
      location: child.location || "",
      notes: child.notes || "",
      ariga: child.ariga ? "yego" : "oya",
      ishuri: child.ariga ? (child.ishuri || "") : "",
      afite_ababyeyi: child.afite_ababyeyi ? "yego" : "oya",
      parent1_name: child.parent1_name || "",
      parent2_name: child.parent2_name || "",
      parent_phone: child.parent_phone || "",
      parent_address: child.parent_address || "",
    });
    setEditingId(child.id);
    setFormErrors({});
    setActiveTab("create");
  };

  const filteredSortedList = useMemo(() => {
    let items = list;
    if (search.child_name) items = items.filter(c => (c.child_name || "").toLowerCase().includes(search.child_name.toLowerCase()));
    if (search.status) items = items.filter(c => c.status === search.status);
    items = [...items].sort((a, b) => {
      const da = new Date(a.created_at).getTime();
      const db = new Date(b.created_at).getTime();
      return sortOrder === "newest" ? db - da : da - db;
    });
    return items;
  }, [list, search, sortOrder]);

  const pagedList = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return filteredSortedList.slice(start, start + PAGE_SIZE);
  }, [filteredSortedList, page]);

  const totalPages = Math.max(1, Math.ceil(filteredSortedList.length / PAGE_SIZE));

  useEffect(() => { setPage(1); }, [search, sortOrder]);

  const pageTitle = mode === "village" ? "Abana Binzererezi"
    : mode === "cell" ? "Abana bo mu Muhanda"
    : "Abana Bari mu Mihanda";

  const pageSubtitle = mode === "village" ? "Abana boherejwe na Isibo/Umunyamabanga bagomba kwoherezwa ku Kagari"
    : mode === "cell" ? "Abana boherejwe n'Imidugudu — kurikirana no gufasha"
    : "Kwandika no kohereza amakuru y'abana babonetse mu mihanda";

  const tabs = mode === "creator"
    ? [["dashboard", "Dashboard"], ["create", "Ongeramo Umwana"], ["list", "Urutonde"], ["search", "Shakisha"]]
    : [["dashboard", "Dashboard"], ["list", pageTitle], ["search", "Shakisha"]];

  const renderList = (rows) => (
    <div className="mihanda-table-wrap">
      <table className="mihanda-table">
        <thead>
          <tr>
            <th>Izina</th><th>Imyaka</th><th>Ariga</th><th>Ababyeyi</th><th>Aho yabonetse</th><th>Uwabashyizemo</th><th>Itariki</th><th>Imiterere</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(c => (
            <tr key={c.id} onClick={() => loadDetail(c.id)}>
              <td>{c.child_name}</td>
              <td>{c.age}</td>
              <td>{c.ariga ? (c.ishuri || "Ariga") : "Ntago yiga"}</td>
              <td>{c.afite_ababyeyi ? (c.parent1_name || "Afite ababyeyi") : "Nta babyeyi afite"}</td>
              <td>{c.location || "—"}</td>
              <td>{c.created_by_name || "—"}</td>
              <td>{new Date(c.created_at).toLocaleDateString("rw-RW")}</td>
              <td><span className={`mihanda-badge mihanda-badge-${STATUS_LABEL[c.status]?.cls}`}>{STATUS_LABEL[c.status]?.label || c.status}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length === 0 && <div className="mihanda-empty">{loading ? "Kuraguza..." : "Nta bana bahari"}</div>}
    </div>
  );

  return (
    <div className="mihanda-wrap">
      <Styles />
      <div className="mihanda-topbar">
        <div>
          <h2 className="mihanda-title">{pageTitle}</h2>
          <p className="mihanda-subtitle">{pageSubtitle}</p>
        </div>
        {mode === "creator" && (
          <button className="mihanda-btn mihanda-btn-primary" onClick={() => { setForm(emptyForm); setEditingId(null); setFormErrors({}); setActiveTab("create"); }}>
            + Ongeramo Umwana
          </button>
        )}
      </div>

      <div className="mihanda-tabs">
        {tabs.map(([key, label]) => (
          <button key={key} className={`mihanda-tab${activeTab === key ? " active" : ""}`} onClick={() => setActiveTab(key)}>
            {label}
          </button>
        ))}
      </div>

      {activeTab === "dashboard" && (
        <>
          <div className="mihanda-card">
            <div className="mihanda-grid">
              <div><div style={{ fontSize: 24, fontWeight: 800, color: "#1a3a5c" }}>{list.length}</div><div className="mihanda-subtitle">Byose</div></div>
              <div><div style={{ fontSize: 24, fontWeight: 800, color: "#16a34a" }}>{list.filter(c => c.status === "Byarangiye").length}</div><div className="mihanda-subtitle">Byarangiye</div></div>
              <div><div style={{ fontSize: 24, fontWeight: 800, color: "#b45309" }}>{list.filter(c => ["Yoherejwe ku Mudugudu", "Yoherejwe ku Kagari"].includes(c.status)).length}</div><div className="mihanda-subtitle">Bitegereje</div></div>
            </div>
          </div>
          <div className="mihanda-card">{renderList(filteredSortedList.slice(0, 8))}</div>
        </>
      )}

      {activeTab === "create" && mode === "creator" && (
        <form className="mihanda-card" onSubmit={handleSubmit}>
          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", margin: "0 0 12px" }}>Amakuru y'umwana</h4>
          <div className="mihanda-grid">
            <div className="mihanda-field">
              <label>Izina ry'umwana <span className="required">*</span></label>
              <input value={form.child_name} onChange={e => updateField("child_name", e.target.value)} />
              {formErrors.child_name && <div className="mihanda-error">{formErrors.child_name}</div>}
            </div>
            <div className="mihanda-field">
              <label>Imyaka y'umwana <span className="required">*</span></label>
              <input type="number" min="0" step="1" value={form.age} onChange={e => updateField("age", e.target.value)} />
              {formErrors.age && <div className="mihanda-error">{formErrors.age}</div>}
            </div>
            <div className="mihanda-field">
              <label>Igitsina</label>
              <select value={form.gender} onChange={e => updateField("gender", e.target.value)}>
                <option value="">--</option>
                <option value="Gabo">Gabo</option>
                <option value="Gore">Gore</option>
              </select>
            </div>
            <div className="mihanda-field">
              <label>Aho yabonetse</label>
              <input value={form.location} onChange={e => updateField("location", e.target.value)} placeholder="Aho yabonetse" />
            </div>
          </div>
          <div className="mihanda-field">
            <label>Ibisobanuro by'inyongera</label>
            <textarea value={form.notes} onChange={e => updateField("notes", e.target.value)} />
          </div>

          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", margin: "18px 0 6px" }}>Amashuri</h4>
          <div className="mihanda-field">
            <label>Umwana ariga? <span className="required">*</span></label>
            <div className="mihanda-radio-row">
              <label className="mihanda-radio-opt">
                <input type="radio" name="ariga" checked={form.ariga === "yego"} onChange={() => updateField("ariga", "yego")} /> Yego, ariga
              </label>
              <label className="mihanda-radio-opt">
                <input type="radio" name="ariga" checked={form.ariga === "oya"} onChange={() => { updateField("ariga", "oya"); updateField("ishuri", ""); }} /> Oya, ntago yiga
              </label>
            </div>
            {formErrors.ariga && <div className="mihanda-error">{formErrors.ariga}</div>}
          </div>
          {form.ariga === "yego" && (
            <div className="mihanda-field">
              <label>Ishuri yigamo <span className="required">*</span></label>
              <input value={form.ishuri} onChange={e => updateField("ishuri", e.target.value)} />
              {formErrors.ishuri && <div className="mihanda-error">{formErrors.ishuri}</div>}
            </div>
          )}

          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", margin: "18px 0 6px" }}>Ababyeyi / Abamurera</h4>
          <div className="mihanda-field">
            <label>Umwana afite ababyeyi cyangwa abamurera? <span className="required">*</span></label>
            <div className="mihanda-radio-row">
              <label className="mihanda-radio-opt">
                <input type="radio" name="afite_ababyeyi" checked={form.afite_ababyeyi === "yego"} onChange={() => updateField("afite_ababyeyi", "yego")} /> Yego
              </label>
              <label className="mihanda-radio-opt">
                <input type="radio" name="afite_ababyeyi" checked={form.afite_ababyeyi === "oya"} onChange={() => updateField("afite_ababyeyi", "oya")} /> Oya, nta babyeyi afite
              </label>
            </div>
            {formErrors.afite_ababyeyi && <div className="mihanda-error">{formErrors.afite_ababyeyi}</div>}
          </div>
          {form.afite_ababyeyi === "yego" && (
            <div className="mihanda-grid">
              <div className="mihanda-field">
                <label>Izina ry'umubyeyi/umurezi wa mbere <span className="required">*</span></label>
                <input value={form.parent1_name} onChange={e => updateField("parent1_name", e.target.value)} />
                {formErrors.parent1_name && <div className="mihanda-error">{formErrors.parent1_name}</div>}
              </div>
              <div className="mihanda-field">
                <label>Izina ry'umubyeyi/umurezi wa kabiri</label>
                <input value={form.parent2_name} onChange={e => updateField("parent2_name", e.target.value)} />
              </div>
              <div className="mihanda-field">
                <label>Telefoni</label>
                <input value={form.parent_phone} onChange={e => updateField("parent_phone", e.target.value)} />
              </div>
              <div className="mihanda-field">
                <label>Aho batuye</label>
                <input value={form.parent_address} onChange={e => updateField("parent_address", e.target.value)} />
              </div>
            </div>
          )}
          {form.afite_ababyeyi === "oya" && (
            <div className="mihanda-card" style={{ background: "#f8fafc", padding: 12 }}>
              <em>Nta babyeyi afite</em> — bizabikwa uko biri, nta mazina y'ababyeyi asabwa.
            </div>
          )}

          <div className="mihanda-actions-row">
            <button type="submit" className="mihanda-btn mihanda-btn-success" disabled={saving}>
              {saving ? "Kohereza..." : editingId ? "Hindura" : "Ohereza ku Mudugudu"}
            </button>
            <button type="button" className="mihanda-btn mihanda-btn-outline" onClick={() => { setForm(emptyForm); setEditingId(null); setFormErrors({}); setActiveTab("list"); }}>
              Reka
            </button>
          </div>
        </form>
      )}

      {activeTab === "list" && (
        <div className="mihanda-card">
          {renderList(pagedList)}
          {filteredSortedList.length > PAGE_SIZE && (
            <div className="mihanda-pagination">
              <button className="mihanda-btn mihanda-btn-outline mihanda-btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Ibanziriza</button>
              <span style={{ fontSize: 12.5, color: "#64748b" }}>Urupapuro {page} / {totalPages}</span>
              <button className="mihanda-btn mihanda-btn-outline mihanda-btn-sm" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Ikurikira →</button>
            </div>
          )}
        </div>
      )}

      {activeTab === "search" && (
        <div className="mihanda-card">
          <div className="mihanda-grid" style={{ marginBottom: 10 }}>
            <div className="mihanda-field">
              <label>Izina ry'umwana</label>
              <input value={search.child_name} onChange={e => setSearch({ ...search, child_name: e.target.value })} />
            </div>
            <div className="mihanda-field">
              <label>Imiterere</label>
              <select value={search.status} onChange={e => setSearch({ ...search, status: e.target.value })}>
                <option value="">Byose</option>
                {Object.keys(STATUS_LABEL).map(k => <option key={k} value={k}>{STATUS_LABEL[k].label}</option>)}
              </select>
            </div>
            <div className="mihanda-field">
              <label>Gutondeka</label>
              <select value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                <option value="newest">Bishya mbere</option>
                <option value="oldest">Bishaje mbere</option>
              </select>
            </div>
          </div>
          {renderList(pagedList)}
          {filteredSortedList.length > PAGE_SIZE && (
            <div className="mihanda-pagination">
              <button className="mihanda-btn mihanda-btn-outline mihanda-btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Ibanziriza</button>
              <span style={{ fontSize: 12.5, color: "#64748b" }}>Urupapuro {page} / {totalPages}</span>
              <button className="mihanda-btn mihanda-btn-outline mihanda-btn-sm" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Ikurikira →</button>
            </div>
          )}
        </div>
      )}

      {activeTab === "detail" && detail && (
        <div className="mihanda-card">
          <button className="mihanda-btn mihanda-btn-outline mihanda-btn-sm" onClick={() => setActiveTab("list")} style={{ marginBottom: 16 }}>
            ← Subira inyuma
          </button>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
            <h3 style={{ margin: 0, color: "#1a3a5c" }}>{detail.child_name}</h3>
            <span className={`mihanda-badge mihanda-badge-${STATUS_LABEL[detail.status]?.cls}`}>{STATUS_LABEL[detail.status]?.label || detail.status}</span>
          </div>

          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", marginBottom: 10 }}>Amakuru y'umwana</h4>
          <div className="mihanda-detail-grid" style={{ marginBottom: 18 }}>
            <div><div className="mihanda-detail-item-label">Imyaka</div><div className="mihanda-detail-item-value">{detail.age}</div></div>
            <div><div className="mihanda-detail-item-label">Igitsina</div><div className="mihanda-detail-item-value">{detail.gender || "—"}</div></div>
            <div><div className="mihanda-detail-item-label">Aho yabonetse</div><div className="mihanda-detail-item-value">{detail.location || "—"}</div></div>
            <div><div className="mihanda-detail-item-label">Ariga</div><div className="mihanda-detail-item-value">{detail.ariga ? "Yego, ariga" : "Oya, ntago yiga"}</div></div>
            {!!detail.ariga && <div><div className="mihanda-detail-item-label">Ishuri</div><div className="mihanda-detail-item-value">{detail.ishuri || "—"}</div></div>}
            <div><div className="mihanda-detail-item-label">Ababyeyi/Abamurera</div><div className="mihanda-detail-item-value">{detail.afite_ababyeyi ? "Afite" : "Nta babyeyi afite"}</div></div>
            {!!detail.afite_ababyeyi && (
              <>
                <div><div className="mihanda-detail-item-label">Umubyeyi wa mbere</div><div className="mihanda-detail-item-value">{detail.parent1_name || "—"}</div></div>
                {detail.parent2_name && <div><div className="mihanda-detail-item-label">Umubyeyi wa kabiri</div><div className="mihanda-detail-item-value">{detail.parent2_name}</div></div>}
                {detail.parent_phone && <div><div className="mihanda-detail-item-label">Telefoni</div><div className="mihanda-detail-item-value">{detail.parent_phone}</div></div>}
                {detail.parent_address && <div><div className="mihanda-detail-item-label">Aho batuye</div><div className="mihanda-detail-item-value">{detail.parent_address}</div></div>}
              </>
            )}
            {detail.notes && <div><div className="mihanda-detail-item-label">Ibisobanuro</div><div className="mihanda-detail-item-value">{detail.notes}</div></div>}
          </div>

          <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", marginBottom: 10 }}>Urwego rushinzwe</h4>
          <div className="mihanda-detail-grid" style={{ marginBottom: 18 }}>
            <div><div className="mihanda-detail-item-label">Umudugudu</div><div className="mihanda-detail-item-value">{detail.umudugudu_name || "—"}</div></div>
            <div><div className="mihanda-detail-item-label">Akagari</div><div className="mihanda-detail-item-value">{detail.akagari_name || "—"}</div></div>
            <div><div className="mihanda-detail-item-label">Uwabashyizemo</div><div className="mihanda-detail-item-value">{detail.created_by_name || "—"}</div></div>
            <div><div className="mihanda-detail-item-label">Itariki yanditswe</div><div className="mihanda-detail-item-value">{new Date(detail.created_at).toLocaleString("rw-RW")}</div></div>
          </div>

          <div className="mihanda-actions-row">
            {mode === "creator" && detail.status === "Yoherejwe ku Mudugudu" && (
              <button className="mihanda-btn mihanda-btn-primary" onClick={() => startEdit(detail)}>✎ Hindura</button>
            )}
            {mode === "village" && detail.status === "Yoherejwe ku Mudugudu" && (
              <button className="mihanda-btn mihanda-btn-success" onClick={handleForwardToAkagari}>Ohereza ku Kagari</button>
            )}
            {mode === "cell" && (AKAGARI_NEXT_STATUS[detail.status] || []).map(([next, label]) => (
              <button key={next} className="mihanda-btn mihanda-btn-success" onClick={() => handleStatusChange(next, label)}>{label}</button>
            ))}
          </div>

          {detail.audit_trail?.length > 0 && (
            <div className="mihanda-card" style={{ marginTop: 16 }}>
              <h4 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", marginBottom: 10 }}>Amateka y'igikorwa</h4>
              <div className="mihanda-table-wrap">
                <table className="mihanda-table">
                  <thead><tr><th>Igikorwa</th><th>Uwakoze</th><th>Uruhare</th><th>Itariki</th></tr></thead>
                  <tbody>
                    {detail.audit_trail.map(a => (
                      <tr key={a.id}><td>{a.action}</td><td>{a.user_name || "—"}</td><td>{a.role || "—"}</td><td>{new Date(a.created_at).toLocaleString("rw-RW")}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
